import academic from "./academic";
import countryselection from "./countrySelection";
import couresdetails from "./courseDetails";
import financials from "./financials";
import futureprospective from "./futureprospective";
import personalintro from "./personalIntro";
import universityselection from "./universitySelection";
import touristfinancials from "./touristFinancials";
import touristintro from "./touristIntroduction";
import touristoccupation from "./touristOccupation";
import touristpurpose from "./touristPurposeOfVisit";
import touristsubjectline from "./touristSubjectLine";
import touristtravelhistory from "./touristTravelHistory";
import loremployee from "./lorEmployee";
import loracademic from "./lorAcademic";
import lorcharacter from "./lorCharacter";
import touristfamilydetails from "./touristFamilyDetails";
import touristreasontoreturn from "./touristreasontoreturn";
import conclusion from "./conclusion";
import gteStudentVisa from "./gteStudentVisa";
const templates = [
  academic,
  countryselection,
  couresdetails,
  financials,
  futureprospective,
  conclusion,
  personalintro,
  universityselection,
  touristfinancials,
  touristintro,
  touristoccupation,
  touristpurpose,
  touristsubjectline,
  touristtravelhistory,
  loremployee,
  loracademic,
  lorcharacter,
  touristfamilydetails,
  touristreasontoreturn,
  gteStudentVisa,
];

export default templates;
